import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
export const client = new ApolloClient({
  link: new HttpLink({
    uri: 'https://es-indexer-graphql.energiswap.exchange',
  }),
  cache: new InMemoryCache(),
  shouldBatch: true,
})

export const stakingClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://es-indexer-graphql.energiswap.exchange',
  }),
  cache: new InMemoryCache(),
  shouldBatch: true,
})

export const blockClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://es-block-indexer-graphql.energiswap.exchange',
  }),
  cache: new InMemoryCache(),
})

// Referral program removed
// export const referralClient = new ApolloClient({
//   link: new HttpLink({
//     uri: GRAPH_NODE_HOST + '/http/subgraphs/name/energi/referral-program',
//   }),
//   cache: new InMemoryCache(),
// })
